import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { Css, Responsive } from '@/ui';
import {
	BaseCell,
	BaseHeader,
} from '../../../../flights/overview/ui/list/columns/Column';
import { IAsset } from '../../../../../contentful';
import EmployerLogo from '../../job/EmployerLogo';
import { FONT_FAMILY_AVENIR_NEXT } from '../../../../../styles/Font';

interface IJobTitleProps {
	title: string;
	employerName: string;
	employerLogo?: IAsset;
}

const styles = css`
	display: flex;
	gap: ${Css.pxToRem(8)};
	flex: 3.5;
	padding-right: 0;

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		flex: 1.5;
	}
`;

const StyledHeader = styled(BaseHeader)`
	${styles}
`;

const StyledCell = styled(BaseCell)`
	${styles}
	align-items: center;
	padding-top: 0;
	padding-bottom: 0;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		img {
			width: ${Css.pxToRem(32)};
			height: ${Css.pxToRem(32)};
		}
	}
`;

const Column = styled.div`
	display: flex;
	flex-direction: column;
	padding-right: ${Css.pxToRem(20)};
`;

const JobTitleName = styled.span`
	font-family: ${FONT_FAMILY_AVENIR_NEXT};
	padding-top: ${Css.pxToRem(8)};
	font-weight: 700;
	line-height: normal;
`;

const JobEmployer = styled.div`
	font-size: ${Css.pxToRem(14)};
	font-weight: 400;
	padding-bottom: ${Css.pxToRem(8)};
`;

export function Header() {
	return <StyledHeader>Job Title</StyledHeader>;
}

export function Cell({ title, employerName, employerLogo }: IJobTitleProps) {
	return (
		<StyledCell>
			<EmployerLogo employerLogo={employerLogo} employerName={employerName} />
			<Column>
				<JobTitleName>{title}</JobTitleName>
				<JobEmployer>{employerName}</JobEmployer>
			</Column>
		</StyledCell>
	);
}
